import React, { useState, useEffect, useMemo } from "react";
import AdCard from "../components/AdCard";
import "./css/prebooking.css";
import { ChakraProvider } from "@chakra-ui/react";

const MyCart = () => {
  return (
    <>
      <div className="pre-booking">
        <div>
          <ChakraProvider>
            <main>
              <section className="station-detail pre-booking-wrappered">
                <div className="all-wrappwer">
                  <div className="pre-cart-header">
                    <h1>My Cart(2)</h1>
                  </div>
                  <div className="pre-booking-cart-container">
                    <div className="pre-cart-container">
                      <div className="pre-cart-list">
                        <AdCard />
                        <AdCard />
                      </div>
                    </div>
                    <div
                      className="pre-booking-cart-lg"
                      style={{ marginTop: "16px" }}
                    >
                      <div className="pre-booking-cart-checkout-wrap">
                        <p>CART SUMMARY</p>
                        <div className="pre-booking-cart-checkout-content">
                          <p className="pre-booking-cart-description pre-booking-cart-description-lg">
                            Subtotal
                          </p>
                          <p className="pre-booking-cart-description pre-booking-cart-description-lg">
                            ₦146,700
                          </p>
                        </div>
                        <div>
                          <button className="pre-booking-btn-cart">
                            Checkout
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pre-booking-cart-md">
                  <div>
                    <p className="pre-booking-cart-descriptions">₦146,700</p>
                  </div>
                  <div>
                    <button className="pre-booking-btn pre-booking-btn-delete">
                      Chekout
                    </button>
                  </div>
                </div>
              </section>
            </main>
          </ChakraProvider>
        </div>
      </div>
    </>
  );
};

export default MyCart;
